var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutUsNodes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1073.793,
    height: 505.136,
    viewBox: "0 0 1073.793 505.136",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Vector_335",
    x: 0,
    y: 0,
    width: 1073.793,
    height: 505.136,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 24,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#3734a9",
    floodOpacity: 0.302
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AboutUsNodes",
    "data-name": "Group 88464",
    transform: "translate(-22.509 -867.071)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 22.51, 867.07)",
    filter: "url(#Vector_335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_335-2",
    "data-name": "Vector 335",
    d: "M0,277.312c43.587,31.533,145.108,91,202.5,76.581,71.737-18.019,89.444-110.818,200.227-132.441S594.778,275.06,680.59,166.494,808.172-13.247,923.5,2.07",
    transform: "translate(75.49 50.48)",
    fill: "none",
    stroke: "#f2b636",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_199",
    "data-name": "Group 199",
    transform: "translate(-25.5 -360.801)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_105",
    "data-name": "Rectangle 105",
    width: 64,
    height: 64,
    rx: 20,
    transform: "translate(248 1590)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_106",
    "data-name": "Rectangle 106",
    width: 23,
    height: 23,
    rx: 10,
    transform: "translate(268 1610)",
    fill: "#7e59d1",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_105-2",
    "data-name": "Rectangle 105",
    width: 64,
    height: 64,
    rx: 20,
    transform: "translate(652.5 1109.604)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_106-2",
    "data-name": "Rectangle 106",
    width: 23,
    height: 23,
    rx: 10,
    transform: "translate(672.5 1129.604)",
    fill: "#7e59d1",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_105-3",
    "data-name": "Rectangle 105",
    width: 64,
    height: 64,
    rx: 20,
    transform: "translate(960 882.402)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_106-3",
    "data-name": "Rectangle 106",
    width: 23,
    height: 23,
    rx: 10,
    transform: "translate(980 902.402)",
    fill: "#7e59d1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUsNodes);
export default __webpack_public_path__ + "static/media/aboutUsNodes.e0e7dcf7f9b44d9376cc7c5477ab3a4e.svg";
export { ForwardRef as ReactComponent };